import { types as compareActionTypes } from '@cinch/oxd-redux/compare/src'
import { types as profileActionTypes } from '@cinch/oxd-redux/profile/src'

import { DEALER_VEHICLE_LISTING_SUCCESS } from '@cinch/oxd-redux/dealer-vehicles/src/types'
import { VEHICLE_LISTING_SUCCESS } from '@cinch/oxd-redux/vehicles/src/types'

import compareEvent from './compare-event'
import dealerFavouriteEvent from './dealer-favourite-event'
import dealerVehicleListing from './dealer-vehicle-listing'
import favouriteEvent from './favourite-event'
import vehicleListing from './vehicle-listing'

const storeEvents: Record<string, any> = {
  [compareActionTypes.COMPARE_ADD]: compareEvent('add'),
  [compareActionTypes.COMPARE_REMOVE]: compareEvent('remove'),
  [profileActionTypes.ADD_FAVOURITE_REQUEST]: dealerFavouriteEvent('add'),
  [profileActionTypes.REMOVE_FAVOURITE_SUCCESS]: dealerFavouriteEvent('remove'),
  [DEALER_VEHICLE_LISTING_SUCCESS]: dealerVehicleListing,
  [profileActionTypes.ADD_DIRECT_FAVOURITE_REQUEST]: favouriteEvent('add'),
  [profileActionTypes.REMOVE_DIRECT_FAVOURITE_SUCCESS]: favouriteEvent('remove'),
  [VEHICLE_LISTING_SUCCESS]: vehicleListing,
}

export default storeEvents
